import { Link } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import type { RequestLinkKind } from '@/types/clientMeetings'

export interface TicketRefTarget {
  kind: RequestLinkKind
  id: string
  ref: string
  url: string | null
  tracked: boolean
}

const linkClass = 'font-semibold text-etn-accent-text-active hover:underline'

// Open Linear in a new tab; help desk tickets and tracked items stay in the app, where Cmd-click still opens a tab.
export function TicketRefLink({ target, className }: { target: TicketRefTarget; className?: string }) {
  if (target.kind === 'linear') {
    if (!target.url) return <span className={className}>{target.ref}</span>
    return (
      <a href={target.url} target="_blank" rel="noreferrer" className={cn(linkClass, className)}>
        {target.ref}
      </a>
    )
  }
  return (
    <Link to={(target.tracked ? `/tracker/${target.id}` : `/admin/tickets/${target.id}`) as never} className={cn(linkClass, className)}>
      {target.ref}
    </Link>
  )
}
